import { useParams } from "react-router-dom";
import { useState } from "react";
import { toast } from "react-hot-toast";

export default function UploadId() {
  const { token } = useParams();

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const upload = async () => {
    if (files.length === 0) {
      toast.error("Upload at least 1 ID image");
      return;
    }

    const fd = new FormData();
    files.forEach(file => fd.append("id_images[]", file));

    setLoading(true);

    const res = await fetch(
      `${process.env.REACT_APP_API_URL}/api/qr-upload/${token}`,
      {
        method: "POST",
        body: fd,
      }
    );

    const data = await res.json();
    setLoading(false);

    if (data.status === "success") {
      toast.success("ID uploaded successfully ✅");
    } else {
      toast.error(data.message || "Upload failed");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-6 rounded shadow w-80">
        <h2 className="font-bold mb-4 text-center">
          Upload Guest ID
        </h2>

        <input
          type="file"
          multiple
          accept="image/*"
          onChange={e => setFiles([...e.target.files])}
        />

        <p className="text-xs text-gray-500 mt-2">
          You can upload 1–3 ID images
        </p>

        {/* PREVIEW */}
        {files.length > 0 && (
          <div className="flex gap-2 mt-3 flex-wrap">
            {files.map((file, i) => (
              <img
                key={i}
                src={URL.createObjectURL(file)}
                className="w-16 h-16 object-cover rounded border"
              />
            ))}
          </div>
        )}

        <button
          onClick={upload}
          disabled={loading}
          className="mt-4 w-full bg-black text-white py-2 rounded"
        >
          {loading ? "Uploading..." : "Upload"}
        </button>
      </div>
    </div>
  );
}
